export default __webpack_public_path__ + "static/media/video_en.3d94c066.mp4";